<template>
  <Flex column>
    <Flex column text-center>{{ lookupData.name }}</Flex>
    <Flex justify-center>
      <LanguageTranslations
        :defaultLanguage="true"
        :lookup-data="lookupData"
        :available-languages="defaultLanguageSelectValue"
      />
      <LanguageTranslations
        :defaultLanguage="false"
        :lookup-data="lookupData"
        :available-languages="languageToTranslateSelectValues"
      />
    </Flex>
  </Flex>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex.vue'
import LanguageTranslations from './LanguageTranslations.vue'

export default {
  name: 'LookupTranslator',
  components: {
    Flex,
    LanguageTranslations,
  },
  props: {
    lookupData: Object,
    availableLanguages: Array,
  },
  computed: {
    defaultLanguageSelectValue() {
      const defaultLanguageSelect = this.lookupData.translations.find(
        (translation) => translation.language.id === this.lookupData.defaultLanguageId,
      )
      return [
        {
          data: {
            label: `${defaultLanguageSelect.language.name} (${defaultLanguageSelect.language.code})`,
            value: defaultLanguageSelect.language.id,
          },
        },
      ]
    },
    languageToTranslateSelectValues() {
      return this.lookupData.translations
        .filter((translation) => translation.language.id !== this.lookupData.defaultLanguageId)
        .map((translation) => ({
          data: {
            label: `${translation.language.name} (${translation.language.code})`,
            value: translation.language.id,
          },
        }))
    },
  },
}
</script>
